import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ProjectmanagerSidebarService {
    selectedMenu: BehaviorSubject<string> = new BehaviorSubject('Hierarchy');
    selectedCardBody: BehaviorSubject<string> = new BehaviorSubject('plantCard');
    selectedMenuMessage = this.selectedMenu.asObservable();
    selectedCardBodyMessage = this.selectedCardBody.asObservable();

    getSelectedMenu(menuName) {
        this.selectedMenu.next(menuName);
    }

    getSelectedCardBody(cardBodyName) {
        this.selectedCardBody.next(cardBodyName);
    }
}
